import React from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux'; // Importa el Provider de Redux
import { store } from './app/store'; // Importa el store configurado
import App from './App';

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

root.render(
  <Provider store={store}> {/* Envuelve tu aplicación con el Provider */}
      <BrowserRouter basename="/servicios">
      <App />
    </BrowserRouter>
  </Provider>
);